export const POLLING_INTERVAL = 4000;
